import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { JoinersLeaversScreen } from '@/features/hr-reports/joiners-leavers-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/hr/reports/joiners-leavers')({
  validateSearch: (search: Record<string, unknown>) => hrReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: JoinersLeaversScreenRoute,
})

function JoinersLeaversScreenRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <JoinersLeaversScreen
      search={search}
      onSearchChange={(next) => void navigate({ to: '/hr/reports/joiners-leavers', search: next })}
    />
  )
}
